import { useContext } from "react";
import type { BillingContextValue } from "@/features/billing/cache";
import { BillingContext } from "@/features/billing/contexts/billing/context";

export function useBilling(): BillingContextValue {
  const context = useContext(BillingContext);
  if (!context) {
    throw new Error("useBilling must be used within a BillingProvider");
  }
  return context;
}
